/**
 * createHtmlLink - Helper function that generates an html anchor element string
 *
 * This does not create a React Element. The return is designed to
 * be passed to the translate function or ReactHtml component
 *
 * @example
 * const link = createHtmlLink("https://google.com", "Google", { className: "Link" })
 * // "<a class="Link" href="https://google.com">Google</a>"
 * // The link string is now ready to be passed to the translate function or with ReactHtml
 * t("archive.restore.success_html", { link })
 *
 * @param {string}  href                    href that will be used by the anchor element created
 * @param {string}  children                The string used as the anchor's nested child
 * @param {object}  [options]               Props object resembling a react component
 * @param {string}  [options.className]     Classes that will be added to the anchor element
 * @param {boolean} [options.newTab=false]  Boolean used to determine if we should open the link in a new tab
 *
 * @returns {string} Html string to passed to translate function or ReactHtml component
 */
export default function createHtmlLink(
  href,
  children,
  { className, newTab = false } = {},
) {
  const classString = className ? `class="${className}" ` : '';
  const newTabString = newTab
    ? 'rel="noopener noreferrer" target="_blank" '
    : '';

  return `<a ${classString}${newTabString}href="${href}">${children || ''}</a>`;
}
